import { XStack, YStack } from '@/components/ui/layout/layout';
import { cn } from '@/lib/utils';

import type { ChatMessage } from './channel-simulator.events';

export const SimulatorChat = ({
  messages,
  selectedSeq,
  onSelect,
}: {
  messages: ChatMessage[];
  selectedSeq: number | null;
  onSelect: (seq: number) => void;
}) => {
  const newestFirst = [...messages].reverse();

  return (
    // Newest first in a reversed column: the browser then keeps the view on the latest message
    <YStack className="min-h-0 flex-1 flex-col-reverse gap-3 overflow-y-auto rounded-lg border border-border bg-background-subtle p-4">
      {messages.length === 0 && (
        <span className="text-xs text-foreground-subtle">
          No messages on this channel yet.
        </span>
      )}
      {newestFirst.map(
        ({ event, isFromDevice, filename, reaction, refusedWebhookStatus }) => (
          <button
            key={event.seq}
            type="button"
            onClick={() => onSelect(event.seq)}
            className={cn(
              'relative flex max-w-[70%] flex-col gap-1 rounded-2xl px-3 py-2 text-left text-sm',
              isFromDevice
                ? 'shell-accent self-end bg-accent text-accent-foreground'
                : 'self-start bg-secondary',
              reaction && 'mb-2',
              event.seq === selectedSeq &&
                'ring-2 ring-foreground ring-offset-2 ring-offset-background-subtle'
            )}
          >
            {filename && (
              <span className="break-all font-mono text-xs opacity-80">
                [file {filename}]
              </span>
            )}
            {event.text && (
              <span className="whitespace-pre-wrap break-words">
                {event.text}
              </span>
            )}
            <XStack className="gap-2 text-[11px] opacity-70">
              <span>{new Date(event.at).toLocaleTimeString()}</span>
              {refusedWebhookStatus !== null && (
                <span>webhook answered {refusedWebhookStatus}</span>
              )}
            </XStack>
            {reaction && (
              <span className="absolute -bottom-3 right-3 rounded-full border border-border bg-background px-1.5 text-xs text-foreground">
                {reaction}
              </span>
            )}
          </button>
        )
      )}
    </YStack>
  );
};
